import { Drawer, Toolbar } from '@mui/material'
import { Path } from '../../types/Path'
import { SidebarContent } from './SidebarContent'

import { ItemColorProps } from './SidebarListItem'

export interface SidebarProps {
  title?: string
  listItems?: Path[]
  basePath?: string
  colors?: ItemColorProps
}

export function Sidebar({ title, listItems, basePath, colors }: SidebarProps) {
  const drawerWidth = 240

  return (
    <Drawer
      variant='permanent'
      sx={{
        width: drawerWidth,
        border: 'none',
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
      }}
    >
      <Toolbar />
      <SidebarContent
        title={title}
        listItems={listItems}
        basePath={basePath}
        colors={colors}
      />
    </Drawer>
  )
}
